import * as React from 'react';
import { I18n, JS } from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';

import { AuthPiece } from 'aws-amplify-react';
import {
  Button,
  FormField,
  FormSection,
  Input,
  InputLabel,
  Link,
  SectionBody,
  SectionFooter,
  SectionFooterPrimaryContent,
  SectionFooterSecondaryContent,
  SectionHeader,
} from 'aws-amplify-react/lib/Amplify-UI/Amplify-UI-Components-React';
import { connect } from 'react-redux';
import { fetchUser } from '../../redux/actions/user.action';

class ConfirmSignIn extends AuthPiece {
  constructor(props) {
    super(props);

    this.checkContact = this.checkContact.bind(this);
    this.confirm = this.confirm.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);

    this._validAuthStates = ['confirmSignIn'];
    this.state = {
      mfaType: 'SMS',
    };
  }

  componentDidMount() {
    window.addEventListener('keydown', this.onKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyDown);
  }

  onKeyDown(e) {
    if (this.props.authState === 'confirmSignIn') {
      if (e.keyCode === 13) {
        // when press enter
        this.confirm();
      }
    }
  }

  checkContact(user) {
    if (!Auth || typeof Auth.verifiedContact !== 'function') {
      throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
    }

    Auth.verifiedContact(user).then((data) => {
      if (!JS.isEmpty(data.verified)) {
        this.props.fetchUser();
        this.changeState('signedIn', user);
      } else {
        const newUser = Object.assign(user, data);
        this.changeState('verifyContact', newUser);
      }
    });
  }

  confirm() {
    const user = this.props.authData;
    const { code } = this.inputs;
    const mfaType = user.challengeName === 'SOFTWARE_TOKEN_MFA' ? 'SOFTWARE_TOKEN_MFA' : null;
    if (!Auth || typeof Auth.confirmSignIn !== 'function') {
      throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
    }

    Auth.confirmSignIn(user, code, mfaType)
      .then(() => {
        this.checkContact(user);
      })
      .catch((err) => this.error(err));
  }

  componentDidUpdate() {
    const user = this.props.authData;
    const mfaType = user && user.challengeName === 'SOFTWARE_TOKEN_MFA' ? 'TOTP' : 'SMS';
    if (this.state.mfaType !== mfaType) this.setState({ mfaType });
  }

  showComponent(theme) {
    const { hide } = this.props;
    if (hide && hide.includes(ConfirmSignIn)) {
      return null;
    }

    return (
      <FormSection theme={theme}>
        <SectionHeader theme={theme}>{I18n.get('Confirm ' + this.state.mfaType + ' Code')}</SectionHeader>
        <SectionBody theme={theme}>
          <FormField theme={theme}>
            <InputLabel>{I18n.get('Code')} *</InputLabel>
            <Input
              autoFocus
              placeholder={I18n.get('Code')}
              theme={theme}
              key="code"
              name="code"
              autoComplete="off"
              onChange={this.handleInputChange}
            />
          </FormField>
        </SectionBody>
        <SectionFooter theme={theme}>
          <SectionFooterPrimaryContent theme={theme}>
            <Button theme={theme} onClick={this.confirm}>
              {I18n.get('Confirm')}
            </Button>
          </SectionFooterPrimaryContent>
          <SectionFooterSecondaryContent theme={theme}>
            <Link theme={theme} onClick={() => this.changeState('signIn')}>
              {I18n.get('Back to Sign In')}
            </Link>
          </SectionFooterSecondaryContent>
        </SectionFooter>
      </FormSection>
    );
  }
}

export default connect(null, { fetchUser })(ConfirmSignIn);
